import { forwardRef } from "react";
import { cx } from "../../utils/cx";
import { Checkbox, CheckboxProps } from "../Checkbox";
import styles from "./ChecklistItem.module.scss";

export type ChecklistItemProps = CheckboxProps;

/**
 * Treez DS — ChecklistItem
 *
 * Figma `ChecklistItem` — checkbox + label row for dense selection lists
 * (`qgFv3OQga6RQ4luvSFuGFP`). Thin wrapper around `Checkbox` with list row
 * metrics (44px min-height).
 */
export const ChecklistItem = forwardRef<HTMLInputElement, ChecklistItemProps>(
    function ChecklistItem(
        { className, label = "Item", showLabel = true, ...rest },
        ref,
    ) {
        return (
            <div
                className={cx(styles.root, className)}
                data-ui="checklist-item"
            >
                <Checkbox
                    className={styles.checkbox}
                    label={label}
                    ref={ref}
                    showLabel={showLabel}
                    {...rest}
                />
            </div>
        );
    },
);

ChecklistItem.displayName = "ChecklistItem";
